import { InjectionToken } from '@angular/core';

export const CLIENTES_API_URL = new InjectionToken<string>('CLIENTES_API_URL');
